var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavthree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8335 10.9999C1.8335 16.0627 5.93741 20.1666 11.0002 20.1666C16.0629 20.1666 20.1668 16.0627 20.1668 10.9999C20.1668 5.93717 16.0629 1.83325 11.0002 1.83325C5.93741 1.83325 1.8335 5.93717 1.8335 10.9999Z",
    stroke: "#2DACF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.917 1.87915C11.917 1.87915 14.667 5.49998 14.667 11C14.667 16.5 11.917 20.1208 11.917 20.1208M10.0836 20.1208C10.0836 20.1208 7.33363 16.5 7.33363 11C7.33363 5.49998 10.0836 1.87915 10.0836 1.87915M2.41113 14.2083H19.5895M2.41113 7.79165H19.5895",
    stroke: "#2DACF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavthree);
export default __webpack_public_path__ + "static/media/navthree.3c18d8dc26d7c24f94933e24f49280e0.svg";
export { ForwardRef as ReactComponent };